import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { useEffect } from "react";

export default function Medical() {

    useEffect(() => {
        const downloadBtn1 = document.getElementById("zacuBtn");
        const downloadBtn2 = document.getElementById("ali_itlais_compilation");
        const downloadBtn3 = document.getElementById("Artificial-Arms-for-Amputees");
        const downloadBtn4 = document.getElementById("ai-glove");
        const downloadBtn5 = document.getElementById("meta");
        const downloadBtn6 = document.getElementById("pemf");
        const downloadBtn7 = document.getElementById("gateway");
        const downloadBtn8 = document.getElementById("hardware");
        const downloadBtn9 = document.getElementById("urip");
        const downloadBtn10 = document.getElementById("mn_summary");

        if (downloadBtn10 && !downloadBtn10.dataset.listenerAttached) {
            downloadBtn10.addEventListener("click", async (e) => {
                e.preventDefault();
        
                try {
                    const response = await fetch("https://crypto-price-prediction.nugenesisou.com/download", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "accept": "application/json",
                        },
                        body: JSON.stringify({
                            bucket_name: "nugenesis-web-docs",
                            file_path: "Pitch_Deck_Documents/document/TEAM-MONTHLY-Summary"
                        }),
                    });
        
                    if (!response.ok) {
                        throw new Error("Failed to fetch download URL");
                    }
        
                    const data = await response.json();
                    window.open(data.download_url, "_blank");
                } catch (error) {
                    alert("Download failed: " + error.message);
                }
            });
        
            // Mark as attached to prevent duplicate listeners
            downloadBtn10.dataset.listenerAttached = "true";
        }

        if (downloadBtn9 && !downloadBtn9.dataset.listenerAttached) {
            downloadBtn9.addEventListener("click", async (e) => {
                e.preventDefault();
        
                try {
                    const response = await fetch("https://crypto-price-prediction.nugenesisou.com/download", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "accept": "application/json",
                        },
                        body: JSON.stringify({
                            bucket_name: "nugenesis-web-docs",
                            file_path: "Pitch_Deck_Documents/document/buddii-khali-URIP-INCUBATOR-IN-PARADISE.pptx"
                        }),
                    });
        
                    if (!response.ok) {
                        throw new Error("Failed to fetch download URL");
                    }
        
                    const data = await response.json();
                    window.open(data.download_url, "_blank");
                } catch (error) {
                    alert("Download failed: " + error.message);
                }
            });
        
            // Mark as attached to prevent duplicate listeners
            downloadBtn9.dataset.listenerAttached = "true";
        }


        if (downloadBtn8 && !downloadBtn8.dataset.listenerAttached) {
            downloadBtn8.addEventListener("click", async (e) => {
                e.preventDefault();
        
                try {
                    const response = await fetch("https://crypto-price-prediction.nugenesisou.com/download", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "accept": "application/json",
                        },
                        body: JSON.stringify({
                            bucket_name: "nugenesis-web-docs",
                            file_path: "Pitch_Deck_Documents/document/NUMeta-hardware"
                        }),
                    });
        
                    if (!response.ok) {
                        throw new Error("Failed to fetch download URL");
                    }
        
                    const data = await response.json();
                    window.open(data.download_url, "_blank");
                } catch (error) {
                    alert("Download failed: " + error.message);
                }
            });
        
            // Mark as attached to prevent duplicate listeners
            downloadBtn8.dataset.listenerAttached = "true";
        }

        if (downloadBtn7 && !downloadBtn7.dataset.listenerAttached) {
            downloadBtn7.addEventListener("click", async (e) => {
                e.preventDefault();
        
                try {
                    const response = await fetch("https://crypto-price-prediction.nugenesisou.com/download", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "accept": "application/json",
                        },
                        body: JSON.stringify({
                            bucket_name: "nugenesis-web-docs",
                            file_path: "Pitch_Deck_Documents/document/Payment-Gateway-Machine"
                        }),
                    });
        
                    if (!response.ok) {
                        throw new Error("Failed to fetch download URL");
                    }
        
                    const data = await response.json();
                    window.open(data.download_url, "_blank");
                } catch (error) {
                    alert("Download failed: " + error.message);
                }
            });
        
            // Mark as attached to prevent duplicate listeners
            downloadBtn7.dataset.listenerAttached = "true";
        }

        if (downloadBtn6 && !downloadBtn6.dataset.listenerAttached) {
            downloadBtn6.addEventListener("click", async (e) => {
                e.preventDefault();
        
                try {
                    const response = await fetch("https://crypto-price-prediction.nugenesisou.com/download", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "accept": "application/json",
                        },
                        body: JSON.stringify({
                            bucket_name: "nugenesis-web-docs",
                            file_path: "Pitch_Deck_Documents/document/Mohamad-PEMF-Frequency-Set.docx"
                        }),
                    });
        
                    if (!response.ok) {
                        throw new Error("Failed to fetch download URL");
                    }
        
                    const data = await response.json();
                    window.open(data.download_url, "_blank");
                } catch (error) {
                    alert("Download failed: " + error.message);
                }
            });
        
            // Mark as attached to prevent duplicate listeners
            downloadBtn6.dataset.listenerAttached = "true";
        }

        if (downloadBtn5 && !downloadBtn5.dataset.listenerAttached) {
            downloadBtn5.addEventListener("click", async (e) => {
                e.preventDefault();
        
                try {
                    const response = await fetch("https://crypto-price-prediction.nugenesisou.com/download", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "accept": "application/json",
                        },
                        body: JSON.stringify({
                            bucket_name: "nugenesis-web-docs",
                            file_path: "Pitch_Deck_Documents/document/meta-medical.zip"
                        }),
                    });
        
                    if (!response.ok) {
                        throw new Error("Failed to fetch download URL");
                    }
        
                    const data = await response.json();
                    window.open(data.download_url, "_blank");
                } catch (error) {
                    alert("Download failed: " + error.message);
                }
            });
        
            // Mark as attached to prevent duplicate listeners
            downloadBtn5.dataset.listenerAttached = "true";
        }

        if (downloadBtn1 && !downloadBtn1.dataset.listenerAttached) {
            downloadBtn1.addEventListener("click", async (e) => {
                e.preventDefault();
        
                try {
                    const response = await fetch("https://crypto-price-prediction.nugenesisou.com/download", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "accept": "application/json",
                        },
                        body: JSON.stringify({
                            bucket_name: "nugenesis-web-docs",
                            file_path: "Pitch_Deck_Documents/document/01_ZACU-Marketing_D1.pdf"
                        }),
                    });
        
                    if (!response.ok) {
                        throw new Error("Failed to fetch download URL");
                    }
        
                    const data = await response.json();
                    window.open(data.download_url, "_blank");
                } catch (error) {
                    alert("Download failed: " + error.message);
                }
            });
        
            // Mark as attached to prevent duplicate listeners
            downloadBtn1.dataset.listenerAttached = "true";
        }

        if (downloadBtn2 && !downloadBtn2.dataset.listenerAttached) {
            downloadBtn2.addEventListener("click", async (e) => {
                e.preventDefault();
        
                try {
                    const response = await fetch("https://crypto-price-prediction.nugenesisou.com/download", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "accept": "application/json",
                        },
                        body: JSON.stringify({
                            bucket_name: "nugenesis-web-docs",
                            file_path: "Pitch_Deck_Documents/document/NuGen ali itlais compilation.docx"
                        }),
                    });
        
                    if (!response.ok) {
                        throw new Error("Failed to fetch download URL");
                    }
        
                    const data = await response.json();
                    window.open(data.download_url, "_blank");
                } catch (error) {
                    alert("Download failed: " + error.message);
                }
            });
        
            // Mark as attached to prevent duplicate listeners
            downloadBtn2.dataset.listenerAttached = "true";
        }
        

        if (downloadBtn3 && !downloadBtn3.dataset.listenerAttached) {
            downloadBtn3.addEventListener("click", async (e) => {
                e.preventDefault();
        
                try {
                    const response = await fetch("https://crypto-price-prediction.nugenesisou.com/download", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "accept": "application/json",
                        },
                        body: JSON.stringify({
                            bucket_name: "nugenesis-web-docs",
                            file_path: "Pitch_Deck_Documents/document/Artificial-Arms-for-Amputees.docx"
                        }),
                    });
        
                    if (!response.ok) {
                        throw new Error("Failed to fetch download URL");
                    }
        
                    const data = await response.json();
                    window.open(data.download_url, "_blank");
                } catch (error) {
                    alert("Download failed: " + error.message);
                }
            });
        
            // Mark as attached to prevent duplicate listeners
            downloadBtn3.dataset.listenerAttached = "true";
        }

        if (downloadBtn4 && !downloadBtn4.dataset.listenerAttached) {
            downloadBtn4.addEventListener("click", async (e) => {
                e.preventDefault();
        
                try {
                    const response = await fetch("https://crypto-price-prediction.nugenesisou.com/download", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "accept": "application/json",
                        },
                        body: JSON.stringify({
                            bucket_name: "nugenesis-web-docs",
                            file_path: "Pitch_Deck_Documents/document/ai-glove.zip"
                        }),
                    });
        
                    if (!response.ok) {
                        throw new Error("Failed to fetch download URL");
                    }
        
                    const data = await response.json();
                    window.open(data.download_url, "_blank");
                } catch (error) {
                    alert("Download failed: " + error.message);
                }
            });
        
            // Mark as attached to prevent duplicate listeners
            downloadBtn4.dataset.listenerAttached = "true";
        }


    }, []);

    return (
        <>
            <Header />

            <main>
                <section class="pad breadcrumbs top-cover">

                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>Medical Field</span>
                    </div>
                    <div data-lavalamp=""></div>
                </section>

                <section class="pad bank-benefits default">

                    <div class="content normal margin-top-content">
                        <div class="data">
                            <div class="text">
                                <h3 class="title">ZACU COIN</h3>
                                <p class="subtitle">

                                </p>
                                <br></br>
                                <p class="subtitle">
                                    A Decentralised True Pegged
                                    System using Copper as a its
                                    utility. The copper Backed Coin
                                    with Tikumbe Mining Limited
                                    (“Company”), providing the raw
                                    commodity colateral


                                </p>

                                <div class="btns">
                                    <a href="#" target="_blank" id="zacuBtn" data-patt="track-btn" class="">Download</a>

                                </div>
                            </div>

                        </div>

                        <div class="img-frame">

                            <img src="images/nugenesisou/pr-illustration-6.png" alt="" />
                        </div>



                    </div>

                </section>

                <section class="pad bank-benefits white bottom0">
                    <div class="content normal">
                        <div data-lavalamp=""></div>
                        <div class="img-frame img-width40">
                            <img src="images/nugenesisou/pr-illustration-16.png" alt="" />
                        </div>

                        <div class="data">
                            <div class="text">
                                <h3 class="title">Developing Technology In The Medical Field</h3>
                                <p class="subtitle subtitle-header">
                                    NU-Fuel

                                </p>

                                <p class="subtitle">
                                    The project is concerned with forming a
                                    solution to the problem of fuel and electric
                                    energy in Lebanon and the world, as the
                                    invention will produce several types of liquid
                                    fuel, almost free, that canbe supplied to
                                    people


                                </p>
                                <div class="btns">
                                    <a href="#" target="_blank" data-patt="track-btn" id="ali_itlais_compilation" class="">Download</a>

                                </div>
                                <br></br> <br></br>
                                <p class="subtitle subtitle-header">
                                    Objectives

                                </p>

                                <p class="subtitle">
                                    1. Securing an alternative energy source to fossil fuels<br></br>
                                    2. Cheap fuel insurance for cars and electric generators<br></br>
                                    3. Helping protect nature by eliminating harmful carbon from combustion<br></br>
                                    4. Securing safe and sustainable fuel<br></br>
                                    5. Create an efficient fuel that replaces fossil fuels without changing the combustion system


                                </p>
                            </div>
                        </div>

                    </div>

                </section>


                <section class="pad bank-benefits white top0 padding-top0">
                    <div class="cards">
                        <div class="wrapper">
                            <div class="item">
                                <div data-lavalamp=""></div>
                                <h3 class="title">Artificial Arm</h3>
                                <p class="subtitle">
                                    An Artificial Arm designed and built by
                                    Nugenesis with a cheaper build to support
                                    less fortunate individuals in the third world
                                    companies.
                                </p>
                                <div class="btns">
                                    <a href="#" id="Artificial-Arms-for-Amputees" target="_blank" class="btn-sm">Download</a>
                                </div>
                                <div class="img-frame"><img src="images/nugenesisou/Artificial Arm.png" alt="" />
                                </div>
                            </div>
                            <div class="item">
                                <div data-lavalamp=""></div>
                                <h3 class="title">Sensory Glove</h3>
                                <p class="subtitle">
                                    Built to translate hand motions into speech
                                    with implementations designed for the Meta
                                    Realm with medical implementations
                                    suitable

                                </p>
                                <div class="btns">
                                    <a href="#" target="_blank" id="ai-glove" class="btn-sm">Download</a>
                                </div>
                                <div class="img-frame height-unset ledgerx-logo"><img src="images/nugenesisou/Sensory Glove.png" alt="" /></div>
                            </div>
                        </div>
                    </div>

                </section>


                <section class="pad bank-benefits default">
                    <div class="content normal">
                        <div class="data">
                            <div class="text">
                                <h3 class="title">Meta Medical EMPT Suit </h3>
                                <p class="subtitle">An EMPT suit Designed for... Recovery Wear, Medical Wear and Workout Wear/Support
                                </p>
                                <div class="btns">
                                    <a href="#" id="meta" target="_blank" data-patt="track-btn" class="">
                                        Download</a>
                                </div>
                            </div>
                            <br></br>
                            <br></br>
                            <div class="text">
                                <h3 class="title">Electro Magnetic Pulse Therapy </h3>
                                <p class="subtitle">An Electro Magnetic Pulse Therapy
                                    Designed for Recovery and Medical
                                    Regerneration designed and developed by
                                    Nugenesis</p>

                                <div class="btns">
                                    <a href="#" id="pemf" target="_blank" data-patt="track-btn" class="">
                                        Download</a>
                                </div>



                            </div>
                        </div>
                        <div class="img-frame">
                        <img src="images/nugenesisou/pr-illustration-17.png" alt="" />
                        </div>
                    </div>
                    <div class="content normal">
                        <div class="data">
                            <div class="text">
                                <h3 class="title">Payment Gateway Machine</h3>
                                <p class="subtitle">A New Payment Gateway Machine able to
                                    both send and request payments from
                                    customers, utalised for cryptocurrancy and
                                    NUCoin </p>
                                <div class="btns">
                                    <a href="#" id="gateway" target="_blank" data-patt="track-btn" class="">
                                        Download</a>
                                </div>
                            </div>

                            <br></br>
                            <br></br>

                            <div class="text">
                                <h3 class="title">NUMeta Hardware</h3>
                                <p class="subtitle">New Hardware technologies that nugenesis is
                                    developing </p>
                                <div class="btns">
                                    <a href="#" id="hardware" target="_blank" data-patt="track-btn" class="">
                                        Download</a>
                                </div>
                            </div>

                        </div>
                        <div class="img-frame">
                        <img src="images/nugenesisou/pr-illustration-19.png" alt="" />
                        </div>
                    </div>



                    <div class="content normal">
                        <div class="data">
                            <div class="text">
                                <h3 class="title">Meta-Arts Realm </h3>
                                <p class="subtitle">A Realm Designed By the Nugenesis
                                    Network For The URIP network which
                                    cointains the largest anthropic and
                                    Celebrity Platfrom</p>
                                <div class="btns">
                                    <a href="#" id="urip" target="_blank" data-patt="track-btn" class="">
                                        Download</a>
                                </div>
                            </div>
                            <br></br>
                            <br></br>
                            <div class="text">
                                <h3 class="title">Blockchain Department </h3>
                                <p class="subtitle">Nugenesis Blockchain Development, designing the next evolution of
                                Blockchain technologies</p>

                                <div class="btns">
                                    <a href="#" id="mn_summary" target="_blank" data-patt="track-btn" class="">
                                        Download</a>
                                </div>



                            </div>
                        </div>
                        <div class="img-frame">
                        <img src="images/nugenesisou/pr-illustration-18.png" alt="" />
                        </div>
                    </div>
                </section>

            </main>
            <Footer />
        </>
    )
}